
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useCountryName } from "../../Components/Countries.js";
import { choose, length, singleton as singleton_1, ofArray, sortBy, append, head, tail, isEmpty, map, filter } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { FSharpSet__Add, FSharpSet__Remove, empty, FSharpSet__Contains, ofList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Set.js";
import { LocationId__get_unwrap } from "../../Shared/Shared.js";
import { createObj, comparePrimitives } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { reactElement, reactApi } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { collect, empty as empty_1, singleton, append as append_1, delay, unfold, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Hierarchy_getPath, Hierarchy_getChildren } from "../../Shared/Location.js";
import { concat, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { rangeDouble } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Range.js";
import { defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { Skeleton } from "../../Components/Skeleton.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { TabsMenu } from "../../Widgets/TabsMenu.js";
import { Button } from "../../Components/Button.js";

export function LocationTreeView(props) {
    let elems_8, elems_4, elems_7, children_2, elems_5, elems_6;
    const t = useTranslation()[0];
    const countryName = useCountryName();
    const locations = filter((location) => !location.IsDeleted, props.Locations);
    const allIds = ofList(map((location_1) => LocationId__get_unwrap(location_1.Id), locations), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
    const patternInput_1 = reactApi.useState(allIds);
    const setExpandedIds = patternInput_1[1];
    const expandedIds = patternInput_1[0];
    const flatRows = toList(unfold((stack) => {
        if (!isEmpty(stack)) {
            const rest = tail(stack);
            const location_4 = head(stack)[0];
            const depth = head(stack)[1] | 0;
            const children = Hierarchy_getChildren(locations, location_4.Id);
            return [[location_4, depth, children], (!isEmpty(children) && FSharpSet__Contains(expandedIds, LocationId__get_unwrap(location_4.Id))) ? append(map((child) => [child, depth + 1], children), rest) : rest];
        }
        else {
            return undefined;
        }
    }, map((root) => [root, 0], sortBy((location_3) => location_3.Name.toLocaleLowerCase(), filter((location_2) => {
        const matchValue = location_2.ParentLocationId;
        if (matchValue == null) {
            return true;
        }
        else {
            return !FSharpSet__Contains(allIds, LocationId__get_unwrap(matchValue));
        }
    }, locations), {
        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
    }))));
    const cellClasses = ofArray(["py-2.5", "px-4", "border-b", "border-border", "text-sm"]);
    const headerClasses = ofArray(["py-2.5", "px-4", "text-sm", "font-semibold", "text-left", "border-b", "border-border"]);
    const toolbarButton = (label, testId, onClick) => reactElement("button", {
        "data-test-id": testId,
        className: join(" ", ["text-sm", "font-semibold", "flex", "items-center", "gap-1.5", "px-3", "py-1.5", "hover:bg-background", "rounded-lg", "transition-colors", "text-text-muted"]),
        onClick: (_arg_1) => {
            onClick();
        },
        children: label,
    });
    return reactElement("div", createObj(singleton_1((elems_8 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2", "mb-3"])], (elems_4 = [toolbarButton(t("category.expand_all"), "location-tree-expand-all", () => {
        setExpandedIds(allIds);
    }), toolbarButton(t("category.collapse_all"), "location-tree-collapse-all", () => {
        setExpandedIds(empty({
            Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
        }));
    })], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), reactElement("table", createObj(ofArray([["className", join(" ", ["w-full", "border-collapse", "text-left", "bg-white"])], (elems_7 = [(children_2 = singleton_1(reactElement("tr", createObj(ofArray([["className", join(" ", ["bg-white"])], (elems_5 = toList(delay(() => append_1(singleton(reactElement("th", {
        className: join(" ", headerClasses),
        children: t("general.name"),
    })), delay(() => append_1(singleton(reactElement("th", {
        className: join(" ", headerClasses),
        children: t("location.path"),
    })), delay(() => append_1(singleton(reactElement("th", {
        className: join(" ", headerClasses),
        children: t("general.description"),
    })), delay(() => append_1(singleton(reactElement("th", {
        className: join(" ", headerClasses),
        children: t("location.address.title"),
    })), delay(() => (props.BusinessUnitsEnabled ? singleton(reactElement("th", {
        className: join(" ", headerClasses),
        children: t("business_units.business_unit"),
    })) : empty_1()))))))))))), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))), reactElement("thead", {
        children: reactApi.Children.toArray(Array.from(children_2)),
    })), reactElement("tbody", createObj(singleton_1((elems_6 = map((tupledArg) => {
        let elems_3;
        const location_6 = tupledArg[0];
        const children_1 = tupledArg[2];
        const id_1 = LocationId__get_unwrap(location_6.Id);
        const hasChildren = !isEmpty(children_1);
        const isExpanded = FSharpSet__Contains(expandedIds, id_1);
        return reactElement("tr", createObj(ofArray([["key", id_1], ["data-test-id", concat("location-tree-row-", ...id_1)], ["className", join(" ", ["group", "hover:bg-[#F2F4FD]", "transition-colors", "cursor-pointer"])], ["onClick", (_arg) => {
            RouterModule_nav(ofArray(["locations", id_1]), 1, 1);
        }], (elems_3 = toList(delay(() => {
            let elems_2, elems_1;
            return append_1(singleton(reactElement("td", createObj(ofArray([["className", join(" ", cellClasses)], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-1"])], (elems_1 = toList(delay(() => append_1(collect((matchValue_1) => singleton(reactElement("div", {
                className: join(" ", ["w-7", "flex-shrink-0"]),
            })), rangeDouble(0, 1, tupledArg[1] - 1)), delay(() => {
                let elems;
                return append_1(hasChildren ? singleton(reactElement("button", createObj(ofArray([["data-test-id", concat("location-tree-toggle-", ...id_1)], ["className", join(" ", ["flex", "items-center", "justify-center", "w-6", "h-6", "rounded", "hover:bg-background", "transition-colors", "text-text-muted", "flex-shrink-0"])], ["onClick", (e) => {
                    e.stopPropagation();
                    const id = LocationId__get_unwrap(location_6.Id);
                    if (FSharpSet__Contains(expandedIds, id)) {
                        setExpandedIds(FSharpSet__Remove(expandedIds, id));
                    }
                    else {
                        setExpandedIds(FSharpSet__Add(expandedIds, id));
                    }
                }], (elems = [reactElement("span", {
                    className: join(" ", toList(delay(() => append_1(singleton("text-[10px]"), delay(() => append_1(singleton("inline-block"), delay(() => append_1(singleton("transition-transform"), delay(() => append_1(singleton("duration-200"), delay(() => (isExpanded ? singleton("rotate-90") : singleton(""))))))))))))),
                    children: "▶",
                })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : singleton(reactElement("span", {
                    className: join(" ", ["w-6", "flex-shrink-0"]),
                })), delay(() => append_1(singleton(reactElement("span", {
                    className: join(" ", ["ml-1"]),
                    "data-test-id": concat("location-tree-row-", id_1, ..."-name"),
                    children: location_6.Name,
                })), delay(() => (hasChildren ? singleton(reactElement("span", {
                    className: join(" ", ["text-xs", "text-text-muted", "ml-1.5"]),
                    children: `(${length(children_1)})`,
                })) : empty_1())))));
            })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => append_1(singleton(reactElement("td", {
                className: join(" ", cellClasses),
                "data-test-id": concat("location-tree-row-", id_1, ..."-path"),
                children: Hierarchy_getPath(locations, location_6),
            })), delay(() => append_1(singleton(reactElement("td", {
                className: join(" ", cellClasses),
                children: location_6.Description,
            })), delay(() => {
                let location_5;
                return append_1(singleton(reactElement("td", {
                    className: join(" ", cellClasses),
                    "data-test-id": concat("location-tree-row-", id_1, ..."-address"),
                    children: (location_5 = location_6, join(", ", filter((part) => (part !== ""), choose((x_4) => x_4, ofArray([location_5.Address.Street, join(" ", choose((x_3) => x_3, ofArray([location_5.Address.ZipCode, location_5.Address.City]))), countryName(location_5.Address.Country)]))))),
                })), delay(() => (props.BusinessUnitsEnabled ? singleton(reactElement("td", {
                    className: join(" ", cellClasses),
                    children: defaultArg(location_6.BusinessUnitName, ""),
                })) : empty_1())));
            }))))));
        })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
    }, flatRows), ["children", reactApi.Children.toArray(Array.from(elems_6))]))))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))]))));
}

export function LocationOverviewTable(props) {
    const matchValue = props.State.Locations;
    const matchValue_1 = props.State.AccountSettings;
    let matchResult, accountSettings, locations;
    if (matchValue.tag === 1) {
        if (matchValue_1.tag === 1) {
            matchResult = 1;
            accountSettings = matchValue_1.fields[0];
            locations = matchValue.fields[0];
        }
        else {
            matchResult = 0;
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return createElement(Skeleton, {
                Variant: "table",
            });
        default:
            return createElement(LocationTreeView, {
                BusinessUnitsEnabled: accountSettings.BusinessUnitsEnabled,
                Locations: locations,
            });
    }
}

export function LocationOverview() {
    let elems_2, elems_1, elems;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const t = useTranslation()[0];
    return reactElement("div", createObj(singleton_1((elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-between", "mb-5", "items-center"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["align-bottom"])], (elems = [createElement(TabsMenu, {
        Tabs: ofArray([{
            IsSelected: false,
            Label: t("navbar.storages"),
            OnClick: () => {
                RouterModule_nav(ofArray(["storages"]), 1, 1);
            },
            TestId: "overview-tab-storages",
        }, {
            IsSelected: true,
            Label: t("navbar.locations"),
            OnClick: () => {
                RouterModule_nav(ofArray(["locations"]), 1, 1);
            },
            TestId: "overview-tab-locations",
        }]),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(Button, {
        ComponentState: "enabled",
        Label: t("location.create_new_location"),
        OnClick: () => {
            RouterModule_nav(ofArray(["locations", "new"]), 1, 1);
        },
        TestId: "new-location-button",
        Variant: "primary",
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement(LocationOverviewTable, {
        State: patternInput[0],
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))]))));
}

